import React from 'react'
import classNames from 'classnames'

import { withStyles, createStyles, WithStyles, Theme } from '@material-ui/core/styles'

import { Omit } from 'types'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import Paper from 'components/Paper'
import Ribbon from 'components/Ribbon'

type PaperProps = React.ComponentProps<typeof Paper>
type RibbonProps = React.ComponentProps<typeof Ribbon>

interface Props extends Omit<PaperProps, 'title'> {
  title?: string | null
  ribbon?: RibbonProps
}

const styles = (theme: Theme) => createStyles({
  root: {
    padding: theme.spacing() * 4,
    backgroundColor: 'transparent',
    textAlign: 'center',
  },
  title: {
    textTransform: 'uppercase',
    letterSpacing: 2,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const EventDetailsHeader: React.SFC<InjectedProps> = ({ title, ribbon, classes, className, ...props }) => {
  return (
    <Paper className={classNames(className, classes.root)} {...props}>
      <Grid direction="column" alignItems="center" spacing={4} container>
        <Grid item>
          <Typography className={classes.title} color="inherit" variant="h5">
            {title}
          </Typography>
        </Grid>
        {ribbon && (
          <Grid item>
            <Ribbon {...ribbon} />
          </Grid>
        )}
      </Grid>
    </Paper>
  )
}

EventDetailsHeader.defaultProps = {
  title: '-',
}

export default withStyles(styles)(EventDetailsHeader)
